import axios from "axios";
import { APIClient } from "../../../helpers/api_helper";
import * as url from "../../../helpers/url_helper";

const api = new APIClient();

  export const getDrivers = async () => {
      try {
        const response = await api.get(`/users/all`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getDriverById = async (id) => {
      try {
        const response = await api.get(`/users/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateDriver = async ( id, data) => {
      try {
        const response = await axios.patch(url.UPDATE_DRIVER +'/'+id, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteDriver = async (id) => {
    try {
      const response = await api.delete(url.DELETE_DRIVER +'/'+id);
      return response;
    } catch (error) {
        throw error;
    }
  };

  export const updateUserRole = async ( data) => {
      try {
        const response = await axios.put('/auth/users/update-role', data);
        console.log('apres update', response)
        return response;
      } catch (error) {
        throw error;
      }
  };